module.exports = __webpack_public_path__ + "img/9791196013264.751a2cb2.jpg";